import { render } from "./Examenes.vue?vue&type=template&id=7349a5f5&scoped=true"
import script from "./Examenes.vue?vue&type=script&lang=js"
export * from "./Examenes.vue?vue&type=script&lang=js"

import "./Examenes.vue?vue&type=style&index=0&id=7349a5f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7349a5f5"]])

export default __exports__